export const snowWhite = '#FFFFFF'
export const backgroundGray = '#F5F5F5'
export const neoBlue = '#08ACE5'
export const navy = '#005471'
export const theBlack = '#000000'
